/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Time-in-force values implemented by at least one create-order posture. Live execution narrows this to GTC; paper execution additionally implements IOC and FOK. GTD is not advertised because neither path has a truthful expiry implementation for this endpoint.
 */
export enum OrderCreateTimeInForce {

    Gtc = 'GTC',

    Ioc = 'IOC',

    Fok = 'FOK'
}
